import React from 'react'
import { useAuth } from '../../contexts/AuthContext'
import { Shield, AlertCircle } from 'lucide-react'

interface ProtectedRouteProps {
  children: React.ReactNode
  requiredPermission: string
  requiredRole?: string
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiredPermission,
  requiredRole
}) => {
  const { hasPermission, hasRole } = useAuth()

  const hasRequiredPermission = hasPermission(requiredPermission)
  const hasRequiredRole = !requiredRole || hasRole(requiredRole)

  if (!hasRequiredPermission || !hasRequiredRole) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="max-w-md w-full text-center">
          <div className="mb-8">
            <div className="mx-auto h-20 w-20 bg-red-100 rounded-full flex items-center justify-center">
              <Shield className="h-10 w-10 text-red-600" />
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mt-6">
              Acceso Denegado
            </h2>
            <p className="text-gray-600 mt-2">
              No tienes permisos suficientes para acceder a esta página.
            </p>
          </div>

          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
            <div className="flex items-center">
              <AlertCircle className="h-5 w-5 text-yellow-600 mr-2" />
              <div className="text-sm text-yellow-800">
                <p><strong>Permiso requerido:</strong> {requiredPermission}</p>
                {requiredRole && (
                  <p><strong>Rol requerido:</strong> {requiredRole}</p>
                )}
              </div>
            </div>
          </div>

          <div className="text-sm text-gray-500">
            Si crees que esto es un error, contacta al administrador del sistema.
          </div>
        </div>
      </div>
    )
  }

  return <>{children}</>
}
